/*--------------------------------------
	불러톡 문구 설정 (관리자)
	라우트: /adm/chat/template, /adm/ajax/chat/template/{list,detail,save,delete,reorder}

	목록은 한 판이고 칩으로 거른다 — 용도(자동답변·빠른답변)가 **배타가 아니라서** 탭이 안 맞는다.
	한 문구가 둘 다일 수 있다. 편집은 모달($j.Ui.Modal)로 연다.

	본문 형식이 셋이라 에디터도 셋이다(서식글 CKEditor · 평문 textarea · 이미지 목록).
	보이는 것은 늘 하나뿐이고, 저장은 **보이는 칸의 값만** 담는다.
--------------------------------------*/
import Util from '../../Common/Util';
const TYPE_HTML = 'html';
const TYPE_TEXT = 'text';
const TYPE_IMG  = 'img';

const TYPE_LABEL = { html: '서식글', text: '평문', img: '이미지' };

export default class ChatTemplate {
	initialize(){
		this.list   = [];
		this.filter = $('#ctRoot').data('kind') || 'all';
		this.modal  = null;     // 편집 모달 핸들
		this.editor = null;     // CKEditor (모달이 열릴 때 만들고 닫을 때 버린다)
		this.editorSeq = 0;     // 에디터를 만든 모달 회차 — 늦게 끝난 생성이 새 모달을 덮지 않게
		this.type   = TYPE_TEXT;
		this.images = [];       // [{file_id, url}] — 순서가 곧 발송 순서
		this.hasCode = false;   // 편집 중인 문구에 상황코드가 붙어 있나 (읽기 전용)
		this.dragFrom = null;   // 끌고 있는 이미지의 자리
		this.order  = [];       // 번개 순서 모달이 들고 있는 임시 순서
		this.orderModal = null;

		this.bind();
		this.markFilter();
		this.loadList();
	}

	/* ── 이벤트 ─────────────────────────────── */
	bind(){
		const self = this;
		$(document).off('.ct');

		$(document).on('click.ct', '#ctFilters .ct-chip', function(){
			self.filter = $(this).attr('data-f');
			self.markFilter();
			self.drawList();
		});

		$(document).on('click.ct', '.js-ct-row',  function(){ self.openEditor($(this).attr('data-num')); });
		$(document).on('click.ct', '.js-ct-new',  function(){ self.openEditor(0); });

		// 순서는 전용 모달에서 — 목록에는 자동답변까지 섞여 있어 '무엇의 순서'인지 안 읽힌다
		$(document).on('click.ct', '.js-ct-order',      function(){ self.openOrder(); });
		$(document).on('click.ct', '.js-ct-ord-up',     function(){ self.moveOrder(+$(this).attr('data-i'), -1); });
		$(document).on('click.ct', '.js-ct-ord-down',   function(){ self.moveOrder(+$(this).attr('data-i'),  1); });
		$(document).on('click.ct', '.js-ct-ord-save',   function(){ self.saveOrder(); });

		// ── 모달 안 (모달은 body 직속이라 document 위임으로 받는다)
		$(document).on('click.ct',  '#ctType button', function(){ self.setType($(this).attr('data-type')); });
		$(document).on('click.ct',  '.js-ct-save',    function(){ self.save(); });
		$(document).on('click.ct',  '.js-ct-del',     function(){ self.remove(); });

		$(document).on('click.ct', '.js-ct-drop', function(){ self.pickImage(); });

		// 드래그&드롭 — dragover 를 막아야 브라우저가 파일을 새 탭으로 열지 않는다.
		// 드랍존 밖에 떨어뜨린 파일도 마찬가지라, 모달이 떠 있는 동안은 document 에서 막는다.
		$(document).on('dragover.ct drop.ct', function(e){
			if( !$('#ctDrop').length ) return;
			e.preventDefault();
		});
		$(document).on('dragenter.ct dragover.ct', '.js-ct-drop', function(e){
			// 순서를 바꾸는 중(파일이 아닌 끌기)이면 드랍존은 반응하지 않는다
			const types = e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.types;
			if( types && Array.prototype.indexOf.call(types, 'Files') === -1 ) return;
			e.preventDefault(); e.stopPropagation();
			$(this).addClass('is-over');
		});
		$(document).on('dragleave.ct', '.js-ct-drop', function(e){
			e.preventDefault(); e.stopPropagation();
			$(this).removeClass('is-over');
		});
		$(document).on('drop.ct', '.js-ct-drop', function(e){
			e.preventDefault(); e.stopPropagation();
			$(this).removeClass('is-over');
			const files = e.originalEvent && e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files;
			if( files && files.length ) $j.F.Upload.uploadFiles(files, { tag: 'talk', context: 'chatTemplate' });
		});
		$(document).on('click.ct', '.js-ct-img-del', function(e){ e.stopPropagation(); self.removeImage(+$(this).attr('data-i')); });

		// 눌러서 크게 보기 — **회원이 받을 카드 그대로** 보여준다($j.Ui.CardNews).
		// 관리자용 확대창을 따로 만들면 보낸 뒤에야 실제 모습을 알게 된다.
		// 끌기와 겹치지 않는다: 끌었으면 click 이 안 난다(dragFrom 으로 한 번 더 막는다).
		$(document).on('click.ct', '.js-ct-img', function(){
			if( self.dragFrom !== null && self.dragFrom !== undefined ) return;
			$j.Ui.CardNews.open({
				items: self.images.map(x => ({ url: x.url })),
				index: +$(this).attr('data-i'),
				title: $('#ctTitle').val() || '',
			});
		});

		// ── 끌어서 순서 바꾸기 (관리자 화면이라 HTML5 DnD 로 충분하다 — 터치는 대상이 아니다)
		$(document).on('dragstart.ct', '.js-ct-img', function(e){
			self.dragFrom = +$(this).attr('data-i');
			$(this).addClass('is-dragging');
			const dt = e.originalEvent.dataTransfer;
			dt.effectAllowed = 'move';
			dt.setData('text/plain', String(self.dragFrom));   // 파이어폭스는 데이터가 없으면 끌기를 시작하지 않는다
		});
		$(document).on('dragend.ct', '.js-ct-img', function(){
			self.dragFrom = null;
			$('#ctImgs .ct-img').removeClass('is-dragging is-over');
		});
		$(document).on('dragover.ct', '.js-ct-img', function(e){
			if( self.dragFrom === null || self.dragFrom === undefined ) return;   // 파일을 끌고 온 것
			e.preventDefault();
			e.originalEvent.dataTransfer.dropEffect = 'move';
			$('#ctImgs .ct-img').removeClass('is-over');
			if( +$(this).attr('data-i') !== self.dragFrom ) $(this).addClass('is-over');
		});
		$(document).on('drop.ct', '.js-ct-img', function(e){
			if( self.dragFrom === null || self.dragFrom === undefined ) return;
			e.preventDefault();
			e.stopPropagation();
			self.dropImage(self.dragFrom, +$(this).attr('data-i'));
			self.dragFrom = null;
		});

		// 업로드 완료 — 공용 업로더가 EventBus 로 알린다.
		// ⚠ `on` 은 **네임스페이스가 첫 인자**이고 핸들러는 `(e, payload)` 를 받는다.
		//   두 인자로 걸면 조용히 아무것도 안 받는다(등록은 되고 이벤트만 안 온다).
		// context 게이트 — 같은 화면의 다른 업로드와 섞이지 않게.
		$j.Common.EventBus.on($j.getNS(this), 'upload:image', (e, payload) => {
			if( $j.F.Upload.getContext() !== 'chatTemplate' ) return;
			(Array.isArray(payload) ? payload : [payload])
				.filter(f => f && f.id)
				.forEach(f => this.images.push({ file_id: f.id, url: this.fileUrl(f) }));
			this.drawImages();
		});
	}

	/* ── 목록 ───────────────────────────────── */
	markFilter(){
		$('#ctFilters .ct-chip').each((i, b) => $(b).toggleClass('is-on', $(b).attr('data-f') === this.filter));
	}

	loadList(keepNum){
		const self = this;
		$.ajax({
			type: 'post', url: '/adm/ajax/chat/template/list', dataType: 'json',
			success(res){
				self.list = res.list || [];
				self.drawList();
				if( keepNum ) self.markRow(keepNum);
			},
		});
	}

	/** 칩 필터는 화면이 건다 — 문구는 많아야 수십 건이라 서버 왕복이 아깝다.
	 *  숨긴 문구는 '숨김' 칩에서만 보인다 — 다른 칩은 전부 숨기지 않은 것 안에서 거른다 */
	visible(){
		const f = this.filter;
		if( f === 'hidden' ) return this.list.filter(r => r.is_hidden === 1);
		const shown = this.list.filter(r => r.is_hidden !== 1);
		if( f === 'all' )   return shown;
		if( f === 'auto' )  return shown.filter(r => !!r.code);
		if( f === 'quick' ) return shown.filter(r => r.is_quick === 1);
		return shown.filter(r => (r.body_type || TYPE_HTML) === f);
	}

	drawList(){
		const rows = this.visible();
		if( !rows.length ){
			$('#ctList').html('<tr><td colspan="4" class="ct-list__empty">해당하는 문구가 없습니다.</td></tr>');
			return;
		}

		$('#ctList').html(rows.map((r) => {
			const type = r.body_type || TYPE_HTML;
			const use  = (r.code ? `<span class="ct-use ct-use--auto" title="${this.esc(r.code_label)}">자동 ${this.esc(r.code)}</span>` : '')
			           + (r.is_quick ? '<span class="ct-use ct-use--quick">번개</span>' : '')
			           || '<span class="ct-use ct-use--off">안 씀</span>';
			// 이미지 문구는 글이 없다 — 미리보기 줄 대신 썸네일(최대 3장)을 보여준다
			const body = (type === TYPE_IMG && (r.thumbs || []).length)
				? `<div class="ct-list__thumbs">`
					+ r.thumbs.map(t => `<img src="${this.esc(t.url)}" alt="">`).join('')
					+ (r.image_count > r.thumbs.length ? `<span class="ct-list__more">+${r.image_count - r.thumbs.length}</span>` : '')
					+ `</div>`
				: `<div class="ct-list__preview">${this.esc(r.preview)}</div>`;

			return `
				<tr class="js-ct-row" data-num="${r.num}">
					<td class="ct-list__use">${use}</td>
					<td>
						<div>${this.esc(r.title)}</div>
						${body}
					</td>
					<td><span class="ct-type ct-type--${type}">${TYPE_LABEL[type] || type}</span></td>
					<td class="ct-list__when">${this.esc(this.when(r.saved_at))}</td>
				</tr>`;
		}).join(''));
	}

	markRow(num){
		$('#ctList .js-ct-row').removeClass('is-on').filter(`[data-num="${num}"]`).addClass('is-on');
	}

	/* ── 편집 모달 ──────────────────────────── */
	openEditor(num){
		const self = this;
		$.get('/adm/ajax/chat/template/detail', { num: num || 0 }, function(row){
			if( !row || row.result === false ){ Util.swalert((row && row.msg) || '대상을 찾을 수 없습니다.'); return; }
			self.images = row.images || [];
			self.showModal(row);
		}, 'json');
	}

	showModal(row){
		const self  = this;
		const isNew = !row.num;

		// 상황코드·라벨·부연설명은 **읽기 전용**이다 — 셋 다 개발자가 DB 에서 관리한다(서비스 머리말).
		// 코드가 없으면 그 칸 자체를 두지 않는다. 고칠 수 없는 컨트롤이 놓여 있으면 "왜 안 되지"를 묻게 된다.
		// 부연설명(code_desc)은 '어떤 경우에 발송되는지'를 사람 말로 적어 둔 것이라, 있으면 그대로 보여준다.
		const autoBox = row.code ? `
		<div class="ct-use-box">
			<div class="ct-use-box__head">자동답변</div>
			<div class="ct-code">${this.esc(row.code)} · ${this.esc(row.code_label || '')}</div>
			${row.code_desc ? `<div class="ct-code-desc">${this.esc(row.code_desc)}</div>` : ''}
		</div>` : '';

		this.modal = $j.Ui.Modal.open({
			id: 'ctEdit',
			variant: 'admin',
			title: isNew ? '새 문구' : '문구 편집',
			width: 720,
			maxWidth: 900,
			onClose: () => { self.destroyEditor(); self.modal = null; },
			html: `
<input type="hidden" id="ctNum" value="${row.num || ''}">

<div class="ct-edit__row">
	<label class="ct-edit__label" for="ctTitle">제목 <span class="ct-edit__hint" id="ctTitleHint">(목록·번개 칩에 표시)</span></label>
	<input type="text" id="ctTitle" class="form-control form-control-sm" maxlength="100" placeholder="예: 배차 완료 안내" value="${this.esc(row.title)}">
</div>

<div class="ct-edit__row">
	<label class="ct-edit__label">이 문구를 어디에 쓰나</label>
	<div class="ct-use-row">
		${autoBox}
		<div class="ct-use-box">
			<label class="ct-use-box__head" for="ctQuick">
				<input type="checkbox" id="ctQuick" ${row.is_quick ? 'checked' : ''}> 빠른답변(번개)
			</label>
			<div class="ct-use-box__hint">채팅창 번개 버튼에서 꺼내 씁니다.</div>
		</div>
	</div>
</div>

<div class="ct-edit__row">
	<label class="ct-edit__label" for="ctHidden">
		<input type="checkbox" id="ctHidden" ${row.is_hidden ? 'checked' : ''}> 목록에서 숨김
	</label>
</div>

<div class="ct-edit__row">
	<label class="ct-edit__label">본문 형식</label>
	<div class="ct-seg" id="ctType">
		<button type="button" data-type="html">서식글</button>
		<button type="button" data-type="text">평문</button>
		<button type="button" data-type="img">이미지</button>
	</div>
</div>

<div class="ct-edit__row">
	<label class="ct-edit__label">내용</label>
	<div class="toolbar-container mb-2" id="ctToolbar"></div>
	<div class="ct-body">
		<div id="ctHtmlWrap"><div id="ctHtml"></div></div>
		<textarea id="ctText" placeholder="문구를 입력하세요">${this.esc(row.body_type === TYPE_TEXT ? row.memo : '')}</textarea>
		<div id="ctImgWrap">
			<div class="ct-drop js-ct-drop" id="ctDrop">
				<i class="fas fa-image"></i>
				<span>이미지를 끌어다 놓거나 <b>눌러서 고르세요</b> · 올린 뒤 <b>끌어서 순서</b>를 바꿉니다</span>
			</div>
			<div class="ct-imgs" id="ctImgs"></div>
		</div>
	</div>
</div>

<div class="ct-edit__foot">
	<button type="button" class="btn btn-success js-ct-save">저장</button>
	${isNew ? '' : '<button type="button" class="btn btn-outline-danger js-ct-del">삭제</button>'}
</div>`,
		});

		this.type    = row.body_type || TYPE_TEXT;
		this.hasCode = !!row.code;
		this.drawImages();
		this.initEditor(row.body_type === TYPE_HTML ? row.memo : '');
		this.setType(this.type);
		setTimeout(() => $('#ctTitle').focus(), 50);
	}

	/** 본문 형식 전환 — 보이는 칸 하나만 남긴다 */
	setType(type){
		if( ![TYPE_HTML, TYPE_TEXT, TYPE_IMG].includes(type) ) type = TYPE_HTML;
		this.type = type;

		$('#ctType button').each(function(){ $(this).toggleClass('is-on', $(this).attr('data-type') === type); });
		// 이미지 문구는 글이 없어 방목록·알림 요약을 **제목으로** 만든다 — 회원도 보는 글이 된다
		$('#ctTitleHint').text(type === TYPE_IMG
			? '(목록·번개 칩 + 회원 방목록·알림에도 표시)'
			: '(목록·번개 칩에 표시)');

		// 에디터 칸(#ctHtml)은 감싼 div 로 숨긴다 — #ctHtml 은 CKEditor 가 소유한 편집 루트라,
		// 직접 display 를 바꾸면 에디터가 붙던 순간의 style 을 포커스 때 되살려 다시 숨는다(글이 안 써진다)
		$('#ctHtmlWrap').toggle(type === TYPE_HTML);
		$('#ctToolbar').toggle(type === TYPE_HTML);
		$('#ctText').toggle(type === TYPE_TEXT);
		$('#ctImgWrap').toggle(type === TYPE_IMG);
	}

	/* ── 이미지 ─────────────────────────────── */
	pickImage(){
		// multiple — PC 파일창에서 여러 장을 고를 수 있다. 앱 브리지는 max_sheet 로 받는다.
		$j.F.Upload.addPhotoHere({ tag: 'talk', context: 'chatTemplate', max_sheet: 10, multiple: true });
	}

	drawImages(){
		if( !$('#ctImgs').length ) return;
		if( !this.images.length ){
			// 안내는 드랍존이 이미 하고 있다 — 같은 말을 두 번 적지 않는다
			$('#ctImgs').html('');
			return;
		}
		// 순서는 **끌어서** 바꾼다. 장마다 ◀▶ 를 두면 버튼이 장 수만큼 늘어 화면이 버튼밭이 된다.
		$('#ctImgs').html(this.images.map((img, i) => `
			<div class="ct-img js-ct-img" draggable="true" data-i="${i}" title="눌러서 크게 보기 · 끌어서 순서 바꾸기">
				<span class="ct-img__no">${i + 1}</span>
				<img src="${this.esc(img.url)}" alt="" draggable="false">
				<button type="button" class="ct-img__del js-ct-img-del" data-i="${i}" aria-label="빼기">&times;</button>
			</div>`).join(''));
	}

	removeImage(i){ this.images.splice(i, 1); this.drawImages(); }

	/** 끌어다 놓은 자리로 **옮긴다**(자리 맞바꿈이 아니라 끼워넣기 — 끌어서 옮기면 그게 기대다) */
	dropImage(from, to){
		if( from === to || from == null || to == null ) return;
		const [moved] = this.images.splice(from, 1);
		this.images.splice(to, 0, moved);
		this.drawImages();
	}

	/* ── 저장·삭제·순서 ─────────────────────── */
	save(){
		const self = this;
		const data = {
			num      : $('#ctNum').val(),
			is_quick : $('#ctQuick').is(':checked') ? 1 : 0,
			is_hidden: $('#ctHidden').is(':checked') ? 1 : 0,
			title    : $('#ctTitle').val(),
			body_type: this.type,
			memo     : this.type === TYPE_TEXT ? $('#ctText').val()
			         : this.type === TYPE_HTML ? (this.editor ? this.editor.getData() : '')
			         : '',
			file_ids : this.type === TYPE_IMG ? this.images.map(x => x.file_id) : [],
		};

		$.ajax({
			type: 'post', url: '/adm/ajax/chat/template/save', dataType: 'json', data,
			success(res){
				if( !res.result ){ Util.swalert(res.msg || '저장하지 못했습니다.'); return; }
				if( self.modal ) self.modal.close();
				self.loadList(res.num);
			},
		});
	}

	remove(){
		const self = this;
		const num = $('#ctNum').val();
		if( !num ) return;
		Util.swalert('이 문구를 삭제할까요?', function(){
			$.ajax({
				type: 'post', url: '/adm/ajax/chat/template/delete', dataType: 'json', data: { num },
				success(res){
					if( !res.result ){ Util.swalert(res.msg || '삭제하지 못했습니다.'); return; }
					if( self.modal ) self.modal.close();
					self.loadList();
				},
			});
		}, true);
	}

	/* ── 번개 순서 모달 ─────────────────────── */
	openOrder(){
		// 화면이 이미 들고 있는 목록에서 번개만 추린다 — 순서만 바꾸는 창이라 다시 받을 게 없다
		this.order = this.list.filter(r => r.is_quick === 1).map(r => ({ num: r.num, title: r.title, body_type: r.body_type }));
		if( !this.order.length ){ Util.swalert('번개에 뜨는 문구가 없습니다.'); return; }

		const self = this;
		this.orderModal = $j.Ui.Modal.open({
			id: 'ctOrder',
			variant: 'admin',
			title: '번개 순서',
			width: 420,
			maxWidth: 520,
			onClose: () => { self.orderModal = null; },
			html: `
<p class="ct-edit__hint">관리자 채팅창의 번개 버튼에서 이 순서로 뜹니다.</p>
<ol class="ct-order" id="ctOrderList"></ol>
<div class="ct-edit__foot">
	<button type="button" class="btn btn-success js-ct-ord-save">순서 저장</button>
</div>`,
		});
		this.drawOrder();
	}

	drawOrder(){
		const last = this.order.length - 1;
		$('#ctOrderList').html(this.order.map((r, i) => `
			<li class="ct-order__item">
				<span class="ct-order__no">${i + 1}</span>
				<span class="ct-order__title">${this.esc(r.title)}</span>
				<span class="ct-order__acts">
					<button type="button" class="btn btn-sm btn-outline-secondary js-ct-ord-up"   data-i="${i}" title="위로"   ${i === 0 ? 'disabled' : ''}>▲</button>
					<button type="button" class="btn btn-sm btn-outline-secondary js-ct-ord-down" data-i="${i}" title="아래로" ${i === last ? 'disabled' : ''}>▼</button>
				</span>
			</li>`).join(''));
	}

	moveOrder(i, d){
		const j = i + d;
		if( j < 0 || j >= this.order.length ) return;
		[this.order[i], this.order[j]] = [this.order[j], this.order[i]];
		this.drawOrder();
	}

	/** 최종 순서를 통째로 보낸다 — 한 칸씩 서버를 왕복하지 않는다(서비스 주석 참조) */
	saveOrder(){
		const self = this;
		$.ajax({
			type: 'post', url: '/adm/ajax/chat/template/reorder', dataType: 'json',
			data: { nums: this.order.map(r => r.num) },
			success(res){
				if( !res.result ){ Util.swalert(res.msg || '순서를 바꾸지 못했습니다.'); return; }
				if( self.orderModal ) self.orderModal.close();
				self.loadList();
			},
		});
	}

	/* ── 에디터 — 모달이 열릴 때 만들고 닫을 때 버린다 ── */
	initEditor(html){
		const self = this;
		if( typeof DecoupledEditor === 'undefined' ) return;   // 없으면 평문·이미지만 쓴다

		const seq = ++self.editorSeq;   // 이 모달 회차 — 다시 열거나 닫으면 올라간다
		DecoupledEditor
			.create(document.querySelector('#ctHtml'), {
				toolbar: [
					'heading', '|', 'fontSize', 'fontFamily', '|',
					'fontColor', 'fontBackgroundColor', '|',
					'bold', 'italic', 'strikethrough', 'underline', '|',
					'alignment', '|', 'indent', 'outdent', '|',
					'link', 'blockQuote', 'insertTable', '|', 'undo', 'redo',
				],
				language: 'ko',
			})
			.then((editor) => {
				// 만드는 사이 모달이 다시 열렸거나 닫혔다 — 이 에디터의 칸은 이제 쓰이지 않는다.
				// 그대로 두면 툴바가 새 모달에 한 줄 더 붙고, self.editor 가 안 보이는 에디터를 가리켜
				// 저장이 빈 본문을 읽을 수 있다. 바로 버린다
				// (칸의 isConnected 로는 못 가른다 — 닫힘 애니메이션 동안은 아직 붙어 있다)
				if( seq !== self.editorSeq ){ editor.destroy().catch(() => {}); return; }
				self.editor = editor;
				editor.setData(html || '');
				const bar = document.querySelector('#ctToolbar');
				if( bar ) bar.appendChild(editor.ui.view.toolbar.element);
				self.setType(self.type);   // 툴바가 생긴 뒤 다시 — 숨김 상태를 맞춘다
			})
			.catch((e) => console.error(e));
	}

	destroyEditor(){
		this.editorSeq++;               // 아직 만드는 중인 에디터가 있으면 끝나는 대로 스스로 버리게
		if( !this.editor ) return;
		try { this.editor.destroy(); } catch(e) {}
		this.editor = null;
	}

	/** 업로드 응답은 {id, path, host} 라 화면에 걸 주소를 여기서 맞춘다 (url 을 주지 않는다) */
	fileUrl(f){
		if( f.url ) return f.url;
		if( !f.path ) return '';
		return (f.host ? String(f.host).replace(/\/$/, '') + '/i/' : '/') + f.path;
	}

	/** 목록의 일시 — 올해면 날짜와 시각만, 지난해면 연도까지 */
	when(v){
		if( !v ) return '';
		const d = dayjs(v);
		if( !d.isValid() ) return String(v);
		return d.format(d.year() === dayjs().year() ? 'MM-DD HH:mm' : 'YYYY-MM-DD');
	}

	esc(s){ return $('<div>').text(s == null ? '' : s).html(); }
}
